import React from "react";
import { Tooltip, IconButton } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

export default function HelpButton(props) {
  return (
    <Tooltip placement="top" interactive title={props.title}>
      <IconButton>
        <HelpOutlineIcon />
      </IconButton>
    </Tooltip>
  );
}
